import React, { Component } from "react";
import "./App.css";
import getDays from "./lambda/getDate";
import daysBetween from "./lambda/daysBetween";
import getSeasonConfig from "./lambda/SeasonConfig";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";

function PreSeason(props) {
  return (
    <div>
      <h2>{props.seasonConfig.name}</h2>
      <h3>starts at </h3>
      {props.seasonConfig.start.toLocaleString()}
    </div>
  );
}

function PostSeason(props) {
  return (
    <div>
      <h2>{props.seasonConfig.name}</h2>
      <h3>ended at </h3>
      {props.seasonConfig.end.toLocaleString()}
    </div>
  );
}
class App extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    const { cookies } = props;
    let seasonConfig = getSeasonConfig();
    let startingCandles = "0";
    let phaseTickets = "0";
    let dailies = false;
    let pass = false;
    let cookie = false;
    let allowCookies = cookies.get("allowCookies");
    console.log(allowCookies);
    if (allowCookies) {
      let cookieState = cookies.get("state");
      if (cookieState !== undefined) {
        cookieState.spirits.forEach((spirit, spiritIndex) => {
          spirit.items.forEach((item, itemIndex) => {
            seasonConfig.spirits[spiritIndex].items[itemIndex].middle.enabled =
              cookieState.spirits[spiritIndex].items[itemIndex].middle.enabled;
          });
        });
        startingCandles = cookieState.startingCandles;
        dailies = cookieState.dailies;
        pass = cookieState.pass;
        phaseTickets = cookieState.phaseTickets;
      }
      cookie = true;
    }

    let currentPhase = 0;

    seasonConfig.phases.some((phase, phaseIndex) => {
      if (getDays(phase.start) < 1 && getDays(phase.end) > 0) {
        currentPhase = phaseIndex;
        return true;
      } else {
        return false;
      }
    });

    this.state = {
      seasonConfig: seasonConfig,
      currentPhase: currentPhase,
      startingCandles: startingCandles,
      phaseTickets: phaseTickets,
      dailies: dailies,
      pass: pass,
      cookie: cookie,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { cookies } = this.props;

    if (this.state.cookie !== prevState.cookie) {
      if (this.state.cookie === true) {
        cookies.set("allowCookies", this.state.cookie, {
          path: "/",
          expires: this.state.seasonConfig.end,
        });
      } else {
        cookies.remove("allowCookies");
        cookies.remove("state");
      }
    }

    if (this.state.cookie === true) {
      if (this.state !== prevState) {
        let cookie = {};
        cookie.spirits = [];
        this.state.seasonConfig.spirits.forEach((spirit, spiritIndex) => {
          cookie.spirits[spiritIndex] = {};
          cookie.spirits[spiritIndex].items = [];
          spirit.items.forEach((item, itemIndex) => {
            cookie.spirits[spiritIndex].items[itemIndex] = {};
            cookie.spirits[spiritIndex].items[itemIndex].middle = {};
            cookie.spirits[spiritIndex].items[itemIndex].middle.enabled =
              this.state.seasonConfig.spirits[spiritIndex].items[
                itemIndex
              ].middle.enabled;
          });
        });
        cookie.startingCandles = this.state.startingCandles;
        cookie.phaseTickets = this.state.phaseTickets;
        cookie.dailies = this.state.dailies;
        cookie.pass = this.state.pass;
        cookies.set("state", cookie, {
          path: "/",
          expires: this.state.seasonConfig.end,
        });
      }
    }
  }

  toggleEnable = (i, j) => (e) => {
    this.setState((prevState) => {
      // e.preventDefault(); was causing dom to not update
      prevState.seasonConfig.spirits[i].items[j].middle.enabled =
        !prevState.seasonConfig.spirits[i].items[j].middle.enabled;
      return {
        ...prevState,
      };
    });
  };

  enableAll = (state) => (e) => {
    this.state.seasonConfig.spirits.map((spirit, spiritIndex) =>
      spirit.items.map((item, itemIndex) =>
        this.setState((prevState) => {
          e.preventDefault();
          prevState.seasonConfig.spirits[spiritIndex].items[
            itemIndex
          ].middle.enabled = state;
          return {
            ...prevState,
          };
        }),
      ),
    );
  };

  render() {
    return (
      <div className="App">
        <body className="App-body">
          <div>
            <h1>Sky Event Calculator</h1>
            <h5>by Stoat</h5>
            {getDays(this.state.seasonConfig.start) > 0 ? (
              <PreSeason seasonConfig={this.state.seasonConfig} />
            ) : getDays(this.state.seasonConfig.end) < 1 ? (
              <PostSeason seasonConfig={this.state.seasonConfig} />
            ) : (
              <div>
                <h2>{this.state.seasonConfig.name}</h2>
                <div className={"questions"}>
                  <table>
                    <tr>
                      <td> How many event tickets do you have?</td>
                      <td>
                        <input
                          type={"number"}
                          value={this.state.startingCandles}
                          onChange={(event) =>
                            this.setState({
                              startingCandles: event.target.value.replace(
                                /\D/,
                                "",
                              ),
                            })
                          }
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Have you collected tickets today?</td>
                      <td>
                        <input
                          type="checkbox"
                          name="dailies"
                          value={this.state.dailies ? "false" : "true"}
                          checked={this.state.dailies === true}
                          onClick={(event) =>
                            this.setState({
                              dailies: event.target.value === "true",
                            })
                          }
                        />
                      </td>
                    </tr>
                    {this.state.seasonConfig.phases[this.state.currentPhase]
                      .poolTickets ? (
                      <tr>
                        <td>
                          {" "}
                          How many bonus tickets have you collected out of{" "}
                          {
                            this.state.seasonConfig.phases[
                              this.state.currentPhase
                            ].poolTickets
                          }{" "}
                          ?{" "}
                        </td>
                        <td>
                          <input
                            type={"number"}
                            value={this.state.phaseTickets}
                            onChange={(event) => {
                              event.target.value.replace(/\D/, "") >
                              this.state.seasonConfig.phases[
                                this.state.currentPhase
                              ].poolTickets
                                ? this.setState({
                                    phaseTickets:
                                      this.state.seasonConfig.phases[
                                        this.state.currentPhase
                                      ].poolTickets,
                                  })
                                : this.setState({
                                    phaseTickets: event.target.value.replace(
                                      /\D/,
                                      "",
                                    ),
                                  });
                            }}
                          />
                        </td>
                      </tr>
                    ) : (
                      <></>
                    )}
                  </table>
                </div>
                <div>
                  {" "}
                  Uncheck the items you've already purchased or don't intend to
                  buy
                </div>
                <button onClick={this.enableAll(true)}>Check All</button>
                <button onClick={this.enableAll(false)}>Uncheck All</button>
                <div id={"main"}>
                  {this.state.seasonConfig.spirits.map(
                    (spirit, spiritIndex) => (
                      <div className={"spirit"}>
                        <table>
                          {spirit.items.map((item, itemIndex) => (
                            <tr>
                              <td>{item.left.name ? item.left.name : ""}</td>
                              <td>{item.left.price ? item.left.price : ""}</td>
                              <td>{item.left.name ? "-" : ""}</td>
                              <td>{item.middle.name}</td>
                              <td>{item.middle.price}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  value={item.middle.enabled ? "false" : "true"}
                                  checked={item.middle.enabled === true}
                                  onChange={this.toggleEnable(
                                    spiritIndex,
                                    itemIndex,
                                  )}
                                />
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              <pre></pre>
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>Total Tickets Selected</td>
                            <td>
                              {spirit.items.reduce(
                                (a, item) =>
                                  item.middle.enabled
                                    ? (a = a + item.middle.price)
                                    : a,
                                0,
                              )}
                            </td>
                          </tr>
                        </table>
                      </div>
                    ),
                  )}
                </div>
                <div className={"calculations"}>
                  {this.state.seasonConfig.phases.map((phase, phaseIndex) => (
                    <div>
                      <h3>Phase {phaseIndex + 1}</h3>
                      Start: {phase.start.toLocaleString()}
                      <br />
                      End: {phase.end.toLocaleString()}
                      <br />
                      {phase.baseTickets} tickets per day <br />
                      {phase.poolTickets ? (
                        <>
                          {phase.poolTickets} tickets in pool <br />
                        </>
                      ) : (
                        ""
                      )}
                      <br />
                      {this.state.currentPhase > phaseIndex ? (
                        "Phase Over"
                      ) : this.state.currentPhase === phaseIndex ? (
                        <div>
                          {getDays(phase.end) - (this.state.dailies ? 1 : 0)}{" "}
                          Days X {phase.baseTickets} Tickets{" "}
                          {phase.poolTickets
                            ? " + ( " +
                              phase.poolTickets +
                              " Tickets - " +
                              this.state.phaseTickets +
                              " Tickets ) "
                            : ""}
                          ={" "}
                          {(getDays(phase.end) - (this.state.dailies ? 1 : 0)) *
                            phase.baseTickets +
                            phase.poolTickets -
                            +this.state.phaseTickets +
                            " Tickets"}
                        </div>
                      ) : (
                        <div>
                          {daysBetween(phase.start, phase.end)} Days X{" "}
                          {phase.baseTickets} Tickets + {phase.poolTickets}{" "}
                          Tickets ={" "}
                          {daysBetween(phase.start, phase.end) *
                            phase.baseTickets +
                            +phase.poolTickets}
                        </div>
                      )}
                    </div>
                  ))}
                  <h3>Totals</h3>
                  <table>
                    <tr>
                      <td>
                        {this.state.startingCandles} Tickets
                        {this.state.seasonConfig.phases.map(
                          (phase, phaseIndex) => (
                            <>
                              {" + "}
                              {this.state.currentPhase > phaseIndex ? (
                                "0 Tickets"
                              ) : this.state.currentPhase === phaseIndex ? (
                                <>
                                  {(getDays(phase.end) -
                                    (this.state.dailies ? 1 : 0)) *
                                    phase.baseTickets +
                                    phase.poolTickets -
                                    +this.state.phaseTickets}{" "}
                                  Tickets
                                </>
                              ) : (
                                <>
                                  {daysBetween(phase.start, phase.end) *
                                    phase.baseTickets +
                                    +phase.poolTickets}{" "}
                                  Tickets
                                </>
                              )}
                            </>
                          ),
                        )}{" "}
                        =
                      </td>
                      <td>
                        {this.state.seasonConfig.phases.reduce(
                          (total, phase, phaseIndex) =>
                            this.state.currentPhase > phaseIndex
                              ? (total = total + 0)
                              : this.state.currentPhase === phaseIndex
                                ? (total =
                                    total +
                                    (getDays(phase.end) -
                                      (this.state.dailies ? 1 : 0)) *
                                      phase.baseTickets +
                                    phase.poolTickets -
                                    +this.state.phaseTickets)
                                : (total =
                                    total +
                                    daysBetween(phase.start, phase.end) *
                                      phase.baseTickets +
                                    +phase.poolTickets),
                          +this.state.startingCandles,
                        )}{" "}
                        Tickets
                      </td>
                    </tr>
                    <tr>
                      <td> Total cost of checked items =</td>
                      <td>
                        {" "}
                        {this.state.seasonConfig.spirits.reduce(
                          (b, spirit) =>
                            (b =
                              b +
                              spirit.items.reduce(
                                (a, item) =>
                                  item.middle.enabled
                                    ? (a = a + item.middle.price)
                                    : a,
                                0,
                              )),
                          0,
                        )}{" "}
                        Tickets
                      </td>
                    </tr>
                  </table>
                </div>
                <div className={"notes"}>
                  <h3>Notes</h3>
                  <br />
                  Leftover tickets at the end of the event disappear. They do
                  not get converted to candles or roll over to the next event.
                  <br />
                </div>
                <div className={"notes"}>
                  <table>
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>
                  </table>
                </div>
                <div className={"cookie"}>
                  Allow cookies to remember selections
                  <input
                    type="checkbox"
                    name="cookie"
                    value={this.state.cookie ? "false" : "true"}
                    checked={this.state.cookie === true}
                    onClick={(event) =>
                      this.setState({ cookie: event.target.value === "true" })
                    }
                  />
                </div>
              </div>
            )}
            <div className={"disclaimer"}>
              Disclaimer: This app is not affiliated with That Game Company or
              Sky: Children of the Light
            </div>
            <div className={"version"}>
              Version {process.env.REACT_APP_VERSION}
            </div>
          </div>
        </body>
      </div>
    );
  }
}

export default withCookies(App);
